<template>
  <header id="eco-mega-menu">
    <!-- embeds -->

    <!-- Desktop mega menu navbar -->
    <b-navbar variant="faded" type="light" class="p-0" id="eco-mega-menu--desktop" :data-navHover="navHover"
      :data-panelHover="panelHover">
      <b-container fluid>
        <b-row no-gutters class="w-100 small nav-bar-outline">

          <!-- Logo -->
          <b-col sm="1" class="d-flex">
            <div class="w-100">
              <div class="mb-0 pl-0 text-center d-block p-4">
                <b-link href="/" v-if="activeLanguage == 'en'">
                  <b-img :src="require('./assets/ECO-Logo.svg')" fluid alt="ECO Canada Logo"
                    class="eco-logo-img"></b-img>
                </b-link>
                <b-link href="/accueil/" v-if="activeLanguage == 'fr'">
                  <b-img :src="require('./assets/ECO-Logo.svg')" fluid alt="ECO Canada Logo"
                    class="eco-logo-img"></b-img>
                </b-link>
              </div>
            </div>
            <!-- <div class="w-50 d-flex align-content-center justify-content-center border-left">
              <h1 class="h-100 text-secondary px-2 d-flex align-items-center text-center eco-logo-text ">
                Environmental Careers <br />
                Organization Canada
              </h1>
            </div> -->
          </b-col>

          <!-- Navigation Menu -->
          <b-col class="nav-menu">
            <b-row class="h-100 eco-nav-items">
              <b-col v-for="menuItem in menuData" :key="menuItem.id" @mouseenter="
                selectMenu({ action: 'navEnter', id: menuItem.id })
                " @mouseleave="
                  selectMenu({ action: 'navLeave', id: menuItem.id })
                  " class="my-auto h-100 d-flex eco-nav-item">
                <b-link :href="menuItem.link">{{ menuItem.name }}
                  <b-icon-chevron-down class="ml-2 bold" font-scale="0.85"></b-icon-chevron-down>
                </b-link>
              </b-col>
            </b-row>
          </b-col>

          <!-- Account / Language / Search -->
          <b-col sm="2">
            <b-row class="h-100 justify-space-between">
              <b-col v-if="!this.isSignedIn" :class="(isSignedIn ? 'col-4 ' : 'col-4 ') +
                'd-flex flex-column align-content-center justify-content-center   ECONavBtn'
                " id="myAccountColumn">
                <a href="/profile" class="h5 mb-0 text-dark">
                  <b-icon-person-fill></b-icon-person-fill>
                  <div id="myAccountText" class="font-weight-bold small">
                    {{ myAccountText }}
                  </div>
                </a>
              </b-col>
              <b-col v-if="this.isSignedIn" :class="(isSignedIn ? 'col-4 ' : 'col-4 ') +
                'd-flex flex-column align-content-center justify-content-center   ECONavBtn'
                " id="logOutColumn">
                <a href="/logout/" class="h5 text-dark mb-0">
                  <b-icon-power></b-icon-power>
                  <div id="logOutText" class="font-weight-bold small">
                    Log Out
                  </div>
                </a>
              </b-col>
              <b-col :class="(isSignedIn ? 'col-4 ' : 'col-4 ') +
                'd-flex flex-column align-content-center justify-content-center   ECONavBtn'
                " id="eco-header-languageColumn">
                <div class="h5 mb-0 h-100 w-100">
                  <div class="font-weight-bold h-100 w-100 align-items-center justify-content-center"
                    v-show="this.activeLanguage !== 'fr'" @click="setLanguage('fr')">
                    FR
                  </div>
                  <div class="font-weight-bold h-100 w-100 align-items-center justify-content-center"
                    v-show="this.activeLanguage == 'fr'" @click="setLanguage('en')">
                    EN
                  </div>
                </div>
              </b-col>
              <b-col :class="'d-flex flex-column align-content-center justify-content-center border-left ECONavBtn '
                + (isSignedIn ? 'col-4' : 'col-4')
                " id="searchColumn">
                <a :href="searchLink" class="h5 text-dark mb-0">
                  <b-icon-search></b-icon-search>
                  <div id="searchText" class="font-weight-bold small">
                    {{ searchText }}
                  </div>
                </a>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </b-navbar>

    <!-- Mega Menu Panel -->
    <b-container v-show="showMegaMenu !== false" @mouseenter="selectMenu({ action: 'panelEnter', id: activeID })"
      @mouseleave="selectMenu({ action: 'panelLeave', id: activeID })" fluid class="eco-megamenu-panel">
      <b-col>
        <!-- Description -->
        <b-col class="eco-megamenu-description row">
          <b-container class="p-4">
            <b-row>
              <b-col class="eco-megamenu-description-inner">
                <h3 class="eco-megamenu-description-title">
                  <b-link :href="menuData[activeID].link">
                    {{ menuData[activeID].name }}
                  </b-link>
                </h3>
                <!-- {{ this.menuData[activeID].description }} -->
              </b-col>
            </b-row>
          </b-container>
        </b-col>

        <!-- Nav Items -->
        <b-col sm="9" class="eco-megamenu-content">
          <div class="container-fluid p-0">
            <div class="h-5 col">
              <b-col v-for="column in this.menuData[activeID].columns" :key="column.heading" class="eco-megamenu-col">
                <b-link v-if="column.link !== '#'" :href="column.link" class="eco-megamenu-column-heading">{{
                  column.heading }}</b-link>
                <strong v-else class="eco-megamenu-column-heading">{{
                  column.heading
                }}</strong>
                <ul>
                  <li v-for="child in column.children" :key="child.name" class="eco-megamenu-column-child">
                    <div class="mt-3" v-if="child.bold">
                      <b-link :href="child.link" class="text">{{
                        child.name
                      }}</b-link>
                    </div>
                    <b-link v-else :href="child.link">{{ child.name }}</b-link>
                  </li>
                </ul>
              </b-col>
            </div>
          </div>
        </b-col>
      </b-col>

      <!-- AD Row -->
      <!-- <div class="row" v-show="(activeID == 0 || activeID == 1 || activeID == 2 || activeID == 4) &&
        activeLanguage == 'en'
        ">
        <div id="eco-ad-spacer"></div>
        <div id="eco-mega-menu--ad-row"> -->
          <!-- <a
            href="https://eco.ca/online-learning/project-management-course-bundle/"
            v-if="(activeID == 0 || activeID == 1 || activeID == 2) &&
            activeLanguage == 'en'"
          >
            <img 
              style="max-height: 140px"
              :src="require('./assets/meridus-banner-compressed.png')"
            />
          </a> -->
          <!-- <a href="https://www.royalroads.ca/programs/bachelor-science-environmental-science" v-if="(activeID == 0 || activeID == 1 || activeID == 2) &&
            activeLanguage == 'en'">
            <img style="max-height: 140px" :src="require('./assets/rru_banner.gif')" />
          </a> -->
          <!-- <a href="https://eco.ca/online-learning/from-theory-to-practice-water-management-in-an-integrated-world/" v-if="(activeID == 4) &&
          activeLanguage == 'en'">
             <img 
              style="max-height: 140px"
              :src="require('./assets/SAIT-banner-may-2022 copy.webp')"
            />
          </a> -->
        <!-- </div>
      </div> -->
    </b-container>



    <!-- Mobile Menu -->
    <b-navbar variant="faded" type="light" class="p-0" id="eco-mega-menu--mobile">
      <b-container fluid>
        <b-row no-gutters class="w-100 small border-bottom">
          <!-- logo -->
          <b-col cols="6" class="d-flex text-center d-block p-3">
            <b-link href="/" class="w-100 h-100 d-flex align-items-center">
              <b-img :src="require('./assets/ECO-Logo.svg')" fluid alt="ECO Canada Logo" class="eco-logo-img"></b-img>
            </b-link>
          </b-col>
          <!-- <b-col cols="4">
            <div class="d-flex h-100 justify-content-center border-left border-right">
              <div class="h-100 d-flex align-items-center text-center eco-logo-text-mobile">
                Environmental Careers Organization Canada
              </div>
            </div>
          </b-col> -->
          <!-- nav button -->
          <b-col cols="6" class="d-flex justify-content-center align-items-center">
            <b-button id="eco-mega-menu--mobile-menu--toggle" v-b-toggle.eco-mega-menu--mobile-menu>
              <b-img :src="require('./assets/menu.svg')"></b-img>
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </b-navbar>

    <!-- Mobile Menu Panel -->
    <b-sidebar id="eco-mega-menu--mobile-menu" right width="100%">
      <div v-if="!this.isSignedIn" class="px-3 py-0">
        <a href="/profile" class="d-block" style="padding: 0 20px">
          <h2 class="text-dark d-flex justify-content-center align-items-center"
            style="border: 1px solid #dedede; padding: 10px; border-radius: 25px 25px 25px 25px;">
            <b-icon-person-fill></b-icon-person-fill>
            <div id="myAccountTextMobile" class="ml-3 font-weight-bold">
              {{ myAccountText }}
            </div>
          </h2>
        </a>
      </div>
      <div v-if="this.isSignedIn" class="px-3 py-0">
        <a href="/logout/" class="d-block" style="padding: 0 20px">
          <h2 class="text-dark d-flex justify-content-center align-items-center"
            style="border: 1px solid #dedede; padding: 10px; border-radius: 25px 25px 25px 25px;">
            <b-icon-person-fill></b-icon-person-fill>
            <div id="myAccountTextMobile" class="ml-3 font-weight-bold">
              Log Out
            </div>
          </h2>
        </a>
      </div>

      <div class="px-3 py-2">
        <!-- Language Toggle -->
        <b-form-group v-slot="{ ariaDescribedby }">
          <b-form-radio-group id="eco-mega-menu--mobile--language-switcher" v-model="activeLanguage"
            :aria-describedby="ariaDescribedby" button-variant="outline-dark" size="sm" name="radio-btn-outline" buttons
            @input="setLanguage">
            <b-form-radio value="en" active style="border-radius: 25px 0 0 25px;">
              <!-- <b-img :src="require('./assets/canada.svg')"></b-img> -->
              <h2 class="mb-0 font-weight-bold">EN</h2>
            </b-form-radio>
            <b-form-radio value="fr" style="border-radius: 0 25px 25px 0;">
              <!-- <b-img :src="require('./assets/quebec.svg')"></b-img> -->
              <h2 class="mb-0 font-weight-bold">FR</h2>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>

        <!-- Mobile Navigation Items -->
        <div v-for="menuItem in menuData" :key="menuItem.id" class="eco-nav-item">
          <div class="w-100 d-flex align-items-center" v-b-toggle="'collapse' + menuItem.id">
            <b-link :href="menuItem.link" class="pl-4 w-75">
              {{ menuItem.name }}
            </b-link>
            <b-icon-chevron-down class="ml-2 w-25" font-scale="0.6"></b-icon-chevron-down>
          </div>
          <!-- Mobile Submenu Items -->
          <b-collapse :id="'collapse' + menuItem.id" class="mb-4">
            <div v-for="column in menuItem.columns" :key="column.heading"
              v-b-toggle="'collapse-submenu-' + menuItem.id + '-' + column.id" class="eco-mega-menu--mobile--submenu">
              <b-link :href="column.link" class="eco-mega-menu--mobile--submenu-header w-75">
                {{ column.heading }}
              </b-link>
              <b-icon-caret-down-fill class="m-auto w-25" font-scale="0.6"></b-icon-caret-down-fill>
              <!-- Mobile Sub-submenu Items -->
              <b-collapse :id="'collapse-submenu-' + menuItem.id + '-' + column.id">
                <ul>
                  <li v-for="child in column.children" :key="child.name" class="eco-mega-menu--mobile--submenu-item">
                    <b-link :href="child.link" class="w-75">{{
                      child.name
                    }}</b-link>
                  </li>
                </ul>
              </b-collapse>
            </div>
          </b-collapse>
        </div>
      </div>
    </b-sidebar>
  </header>
</template>

<script>
import Vue from "vue";
import { debounce } from "debounce";
// import menuLayout from './menu.js'
// import menuLayoutFr from './menu-fr.js'

import {
  LayoutPlugin,
  LinkPlugin,
  NavbarPlugin,
  ImagePlugin,
  SidebarPlugin,
  FormRadioPlugin,
  FormGroupPlugin,
  ButtonPlugin,
  VBToggle,
  BIcon,
  BIconCaretDownFill,
  BIconSearch,
  BIconPersonFill,
  BIconPower,
} from "bootstrap-vue";

Vue.use(LayoutPlugin);
Vue.use(LinkPlugin);
Vue.use(ImagePlugin);
Vue.use(NavbarPlugin);
Vue.use(SidebarPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormRadioPlugin);
Vue.use(ButtonPlugin);
Vue.directive("b-toggle", VBToggle);
Vue.component("BIcon", BIcon);

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";


export default {
  name: "EcoMegaMenu",

  created: function () {
    //check current language
    var c = this.getCookie("pll_language");
    //check if dotnet - <head> has ID
    var isDotNET = document.querySelector("head").id.length > 0;
    console.log("begin by checking for lang cookie:", c);
    if (document.querySelector("html").getAttribute("lang") && !isDotNET) {
      console.log("checking for html language attr");
      if (document.querySelector("html").getAttribute("lang").includes("fr")) {
        this.activeLanguage = "fr";
      } else {
        this.activeLanguage = "en";
      }
    } else if (c) {
      this.activeLanguage = c;
      console.log("cookie already set:", c);
    } else {
      // else set to english - user probably came to login page directly without hitting WP first
      this.activeLanguage = "en";
      console.log(
        "No cookie - did user come straight to login, skipped WP? setting to default, en"
      );
    }
    console.log("current pll_language:", this.activeLanguage);

    // get from js file
    if (this.activeLanguage == "en") {
      this.menuData = window.menuLayout;
    } else {
      this.menuData = window.menuLayoutFr;
    }

    // assign ids to individual columns
    this.menuData.forEach(function (v) {
      // console.log(i,v)
      v.columns.forEach(function (v2, i2) {
        v2.id = i2;
      });
    });

    //check if signed in
    var s = this.getCookie("hXdervg");
    console.log("currently signed in?:", s);
    if (s) {
      this.isSignedIn = true;
    } else {
      this.isSignedIn = false;
      console.log("not signed in");
    }

    console.log("current menu:", this.menuData);
  },
  methods: {
    selectMenu: function (el) {
      // console.log(el)

      // first check if leaving
      var action = (el) => {
        if (el.action == "panelLeave") {
          this.panelHover == false;
        } else if (el.action == "navLeave") {
          // a fix for madness
          if (this.panelHover == false) {
            return;
          }
          this.navHover == false;
        }

        //if both have been left without reactivating
        if (!this.panelHover && !this.navHover) {
          this.showMegaMenu = false;
          // console.log('hiding both')
        } else {
          this.showMegaMenu = true;
        }

        if (el.action == "navEnter") {
          this.navHover == true;
          this.activeID = el.id;
          this.showMegaMenu = true;
        }

        if (el.action == "panelEnter") {
          this.panelHover == true;
          this.activeID = el.id;
          this.showMegaMenu = true;
        }
      };

      debounce(action(el), 1300);
      // console.log("id:", this.activeID, "el:", el)
      // console.log('navHover:',this.navHover, 'panelHover:',this.panelHover)
    },
    setLanguage: function (lang) {
      console.log("setting language to", lang);
      this.activeLanguage = lang;

      //if we have var set to disable switcher
      if (window.disableLang) {
        console.log("switcher disabled");
        return;
      }

      switch (lang) {
        case "en":
          this.setCookie("pll_language", "en", 1);
          break;
        case "fr":
          this.setCookie("pll_language", "fr", 1);
          break;
      }
      debounce(lang, 1300);
      const altLangElement = Array.from(document.getElementsByTagName("link"))?.find(
        el => el.getAttribute("hreflang") === lang
      );
      const aspNetElement = document.getElementById("aspnetForm");
      if (altLangElement?.getAttribute("href")) {
        window.location.assign(altLangElement.getAttribute("href"));
      } else if (aspNetElement) {
        window.location.reload();
      } else {
        switch (lang) {
          case "en":
            window.location.assign('/');
            break;
          case "fr":
            window.location.assign('/accueil/');
            break;
        }
      }
      // window.location.reload();
    },
    getCookie: function (cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    setCookie: function (cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie =
        cname + "=" + cvalue + ";" + expires + ";domain=.eco.ca" + ";path=/";
      if (cname == "pll_language") {
        if (cvalue) {
          this.activeLanguage = cvalue;
          console.log("updated");
        }
      }
    },
  },
  computed: {
    myAccountText: function () {
      if (this.isSignedIn == true) {
        if (this.activeLanguage == "en") {
          return "My Profile";
        } else return "Mon profil";
      } else {
        if (this.activeLanguage == "en") {
          return "Log In";
        } else {
          return "Connectez-vous";
        }
      }
    },
    searchText: function () {
      if (this.activeLanguage == "en") {
        return "Search";
      } else return "Recherche";
    },
    searchLink: function () {
      if (this.activeLanguage == "en") {
        return "/search";
      } else return "/recherche";
    },
  },
  components: {
    // HelloWorld
    BIconCaretDownFill,
    BIconSearch,
    BIconPersonFill,
    BIconPower,
  },
  data() {
    return {
      menuData: null,
      activeID: 0,
      navHover: false,
      panelHover: false,
      showMegaMenu: false,
      isSignedIn: false,
      // language
      activeLanguage: null,
    };
  },
};
</script>

<style scoped>
/* box sizing fix, overrides ASP site */
#eco-header * {
  box-sizing: border-box !important;
}

#eco-mega-menu {
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  z-index: 1000;
  position: fixed;
  top: 0;
  width: 100vw;
  /* padding-bottom:100%; */
}

.nav-bar-outline {
  box-shadow: 0 0 10px -5px rgba(0, 0, 0, 0.3);
}

#eco-mega-menu nav {
  background: white;
}

#eco-mega-menu--desktop,
#eco-mega-menu--mobile {
  transition: top 0.4s ease-in;
}

/* Ads */

/* @font-face {
    font-family: 'Titillium Web';
    src: url(./assets/TitilliumWeb-Regular.woff2);
  }
  @font-face {
    font-family: 'Titillium Web';
    src: url(./assets/TitilliumWeb-Bold.woff2);
    font-weight: bold;
  } */

#eco-ad-spacer {
  width: 25%;
}

#eco-mega-menu--ad-row {
  /* font-family: 'Titillium Web'; */
  max-height: min(160px, 8vh);
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  transform: translateX(-15px);
  box-shadow: 0 0 30px -10px rgba(0, 0, 0, 0.52);
  cursor: pointer;
  /* remove */
}

#eco-mega-menu--ad-row:hover {
  box-shadow: 0 0 30px -20px rgba(0, 0, 0, 0.72);
}

#ad-img,
#ad-img img,
#ad-logo {
  height: 90px;
  width: 200px;
  display: flex;
  align-content: center;
  justify-content: center;
}

#ad-logo {
  width: 140px;
}

#ad-logo img {
  width: 130px;
  object-fit: contain;
}

#ad-copy {
  width: 280px;
  height: 90px;
  text-align: center;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

#ad-copy #ad-heading {
  font-size: 36px;
  font-weight: 600;
  color: white;

  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}

#ad-copy #ad-subheading {
  font-size: 14px;
  font-weight: 300;
  color: #6d2077;
  margin-top: 4px;
}

#ad-btn {
  display: inline;
  align-items: center;
  margin: auto;
  max-width: 160px;
  padding: 15px;
}

#ad-btn button {
  line-height: 1.5;
  background: transparent;
  border: 1px solid white;
  height: 50px;
  display: flex;
  padding: 0px;
}

#ad-btn button:hover {
  background: rgba(255, 255, 255, 0.318);
  /* border-color: #00A3E0; */
}

#ad-btn .btnText {
  font-family: "Titillium Web", "Open Sans" !important;
  line-height: 1.2;
  font-size: 11px;
  color: white;
  width: auto;
  height: 100%;
  padding: 4px;
  display: flex;
  align-items: center;
  font-weight: 300 !important;
}

/* #ad-btn button:hover .btnText{
 color: #00A3E0;
} */

#ad-btn .btnIcon {
  width: 35px;
  height: 100%;
  color: white;
  padding: 9px;
  text-align: center;
  border-left: 1px solid white;
  display: flex;
  align-items: center;
  margin: auto;
}

#ad-btn .btnIcon object {
  fill: white !important;
  stroke: white !important;
  max-height: 20px;
  margin: auto;
  width: 100%;
}

.bi-caret-down-fill {
  margin-left: 0.5rem;
}

/* mobile */
@media screen and (max-width: 1024px) {
  #eco-mega-menu--desktop {
    display: none;
  }

  #eco-mega-menu--mobile .eco-logo-img {
    max-height: 60px;
    min-width: 100%;
  }

  #eco-mega-menu--mobile-menu--toggle {
    height: 100%;
    width: 120px;
    background-color: transparent;
    margin-left: auto;
    border: 1px solid transparent;
    /* display: flex; */
  }

  #eco-mega-menu--mobile-menu--toggle img {
    max-height: 35px;
  }

  .eco-logo-text-mobile {
    font-size: max(12px, 2vw);
    color: #2d2d2d !important;
    font-weight: 300 !important;
    line-height: 1.25;
    padding: 1.5vw;
  }

  .eco-nav-item {
    /* flex:0 0 auto; */
    text-align: left;
    width: 100%;
  }

  .eco-nav-item a {
    min-height: 1.5em;
    width: 900px;
    font-weight: 100;
    font-size: 1.3rem;
    line-height: 3.6rem;
    color: #2d2d2d;
    margin: auto 0;
    text-decoration: none;
    /* transition: background-color .2s ease-in; */
  }

  .eco-nav-item:hover,
  .eco-nav-item a:hover,
  .eco-nav-item a:focus {
    color: #2d2d2d !important;
  }

  /* .eco-mega-menu--mobile--submenu{
  } */
  .eco-mega-menu--mobile--submenu a {
    padding-left: 2em;
    font-size: 14px;
    font-weight: 400;
    padding-top: 15px;
    line-height: 20px;
    display: inline-flex;
  }

  .eco-mega-menu--mobile--submenu ul {
    padding: 0.4em 0;
  }

  .eco-mega-menu--mobile--submenu ul a {
    padding-left: 1em;
  }

  .eco-mega-menu--mobile--submenu-item {
    list-style: none;
    display: flex;
    line-height: 36px;
    padding-left: 30px;
  }

  .b-sidebar>.b-sidebar-header {
    border: none;
    background: transparent;
    box-shadow: none;
    text-align: right;
  }

  .b-sidebar .b-sidebar-header button {
    background: transparent;
    text-align: revert;
  }

  .b-sidebar.b-sidebar-right>.b-sidebar-header .close {
    margin-left: auto;
    margin-right: 0.25em;
    margin-top: 0.5em;
    font-size: 36px;
  }

  #eco-mega-menu--mobile--language-switcher {
    width: 100%;
    padding: 0 20px;
  }

  #eco-mega-menu--mobile--language-switcher label {
    border: 1px solid #dedede;
    padding: 10px;
    border-radius: 0;
    background: none !important;
  }

  #eco-mega-menu--mobile--language-switcher label.active {
    border: 1px solid rgba(6, 81, 2, 0.961);
    color: rgba(6, 81, 2, 0.961) !important;
  }

  #eco-mega-menu--mobile--language-switcher label:not(.active) {
    filter: saturate(0.2) opacity(0.8);
  }

  #eco-mega-menu--mobile--language-switcher img {
    max-height: 32px;
  }
}

/* desktop */
@media screen and (min-width: 1024px) {
  #eco-mega-menu--mobile {
    display: none;
  }

  .eco-nav-item {
    /* flex:0 0 auto; */
    align-items: center;
    justify-content: center;
    text-align: center;
    width: auto;
    border: 1px solid transparent;
  }

  .eco-nav-items a {
    min-height: 100%;
    display: flex;
    align-items: center;
    font-weight: 100;
    font-size: min(1rem, 0.8vw);
    color: #2d2d2d;
    margin: auto 0;
    text-decoration: none;
    transition: background-color 0.1s ease-in-out;

    /* transition: background-color .2s ease-in; */
  }

  .eco-nav-item:first-of-type {
    margin-left: 15px;
  }

  .eco-nav-item:hover,
  .ECONavBtn:hover {
    background-color: rgba(0, 0, 0, 0.022);
    border: 1px solid rgba(0, 0, 0, 0.042);
    text-decoration: none;
    cursor: pointer;
  }

  .eco-nav-item:hover:first-of-type {
    border-left-color: transparent;
  }

  .eco-nav-item:hover:last-of-type {
    border-right-color: transparent;
  }

  .ECONavBtn a div {
    font-size: min(1rem, 0.9vw);
  }
}

/* Laptops */
@media screen and (min-width: 1024px) and (max-width: 1350px) {
  .eco-nav-items a {
    font-weight: 500;
    font-size: min(1rem, 1vw);
  }
}

.eco-logo-img {
  max-height: 70px;
  min-width: auto;
}

.eco-logo-text {
  font-size: min(0.8vw, 12px);
  color: #2d2d2d;
  font-weight: 300 !important;
}

.eco-nav-items {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  align-items: flex-start;
}

.eco-megamenu-panel {
  font-size: 0.8rem;
  text-align: left;
  height: auto;
  width: 40%;
  min-height: 420px;
  backdrop-filter: opacity(0.1);
  /* not sure why this affects the :before div*/
  padding: 2vh 0px;
  border-bottom: 1px solid #dedede;
  z-index: 500;
  background: white;
  position: relative;
  box-shadow: 2px 0 3px -2px rgba(0, 0, 0, 0.2),
    -2px 0 3px -2px rgba(0, 0, 0, 0.2),
    0 2px 3px -2px rgba(0, 0, 0, 0.2);
  border-radius: 0 0 25px 25px;
}

.eco-megamenu-panel:before {
  content: "";
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 40%;
  opacity: 0.1;
  z-index: -1;
  background-clip: border-box;
  background: url(./assets/megabg.png);
  background-color: white;
  background-repeat: no-repeat;
  background-position: center bottom -170px;
  /* background-position-x:left 60px; */
}

.eco-megamenu-panel .eco-megamenu-column-child a,
a.eco-megamenu-column-heading {
  color: #2d2d2d;
  max-width: auto;
  display: block;
}

.eco-megamenu-panel a:hover {
  color: #3a9b42;
  text-decoration: none;
}

.eco-megamenu-panel ul {
  padding: 0;
  margin-top: 10px;
}

/* description */
.eco-megamenu-description-title {
  font-size: 1.2rem;
  font-weight: 750;
  /* margin-bottom: 1rem; */
}

.eco-megamenu-description-title a {
  /* font-family: "Open Sans"; */
  color: #2d2d2d;
}

.eco-megamenu-description-inner {
  background: #fefefe;
  /* border: 1px solid #2d2d2d; */
  /* padding: 25px;
  margin: 15px; */
  /* box-shadow: 0 0 10px -5px rgba(0, 0, 0, 0.3); */
  /* transition: box-shadow 0.3s linear; */
}

.eco-megamenu-description-inner:hover {
  /* box-shadow: 0 0 20px -10px rgba(0, 0, 0, 0.7); */
}

.eco-megamenu-description-inner,
.eco-nav-item {
  line-height: 1.5;
}

/* links */

.eco-megamenu-col {
  padding-top: 25px;
  animation: 0.23s fadeInOpacity ease-in;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.25;
  }

  75% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}

.eco-megamenu-column-heading {
  font-weight: 900;
  /* margin-bottom: 0.4rem; */
  line-height: 1.5;
}

.eco-megamenu-column-child {
  list-style: none;
  margin-bottom: 10px;
  line-height: 1.2;
}

#myAccountColumn:hover svg,
#searchColumn:hover svg,
#logOutColumn:hover svg {
  /* opacity:0; */
  font-size: 90%;
  margin-right: 10%;
  display: none !important;
}

#myAccountColumn a,
#searchColumn a,
#logOutColumn a {
  display: flex;
  flex: 1 auto;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-decoration: none;
}

#myAccountColumn svg,
#searchColumn svg,
#logOutColumn svg {
  opacity: 1;
  transition: margin-right 0.25s ease-in-out, font-size 0.25s ease-in-out;
}

#myAccountColumn:hover #myAccountText,
#searchColumn:hover #searchText,
#logOutColumn:hover #logOutText {
  opacity: 1;
  position: relative;
  width: 100%;
  display: inline-block;
  /* margin-right: 0; */
}

#myAccountText,
#logOutText,
#searchText {
  display: none;
  opacity: 0;
  width: 0%;
  text-overflow: clip;
  /* white-space: nowrap; */
  /* height: 100%; */
  /* display: block; */
  align-items: center;
  /* top:0; */
  /* margin-right:-150%; */
  /* left:0; */
  justify-content: center;
  /* transition: opacity 0.5s, width 0.15s ease-in-out; */
  animation: 0.125s textFade ease-in;
}

@keyframes textFade {
  0% {
    opacity: 0;
    display: none;
  }

  50% {
    opacity: 0.25;
    display: block;
  }

  75% {
    opacity: 0.6;
    display: block;

  }

  100% {
    opacity: 1;
    display: block;

  }
}

#eco-header-languageColumn,
#eco-header-languageColumn div.h5 div {
  display: flex;
}
</style>
